/** @format */
import { ModelListing } from '@toucan/client/global/model';

import { ElementBreakpointsStatus } from '@toucan/client/shared/hooks/use-element-breakpoints';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ModelCardProps = {
    modelListing?: ModelListing;
    'data-testid'?: string;
    className?: string;
    onCreateAlert?: (model: ModelListing) => void;
};

// eslint-disable-next-line @mpb-com/mpb/require-constants-file, @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
export enum ModelCardBreakpointsEnum {
    SMALL = 'small',
    MEDIUM = 'medium',
}

export const modelCardBreakpoints = {
    [ModelCardBreakpointsEnum.SMALL]: 500,
    [ModelCardBreakpointsEnum.MEDIUM]: 800,
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ModelCardBreakpointsState = ElementBreakpointsStatus<
    typeof modelCardBreakpoints
>;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledModelCardProps = Pick<
    ModelCardProps,
    'data-testid' | 'className'
> & {
    modelCardBreakpointsState: ModelCardBreakpointsState;
    isOutOfStock: boolean;
};
